module.exports = "/_next/static/images/bikeMobile-56a4e872de6a59c9a37769891008058c.svg";